// extracted by mini-css-extract-plugin
export default {"main":"Mainstyles_main__i2V4g"};